function AuthInput(props) {
    return (
        <>
            <label className="block text-gray-700 text-sm font-bold mb-2">
                { props.label }
            </label>
            <input 
                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline" 
                name={props.name} type={props.type} placeholder={props.placeholder}
                value={props.value} onChange={props.onChange}
            />
        </>
    )
}

export { AuthInput };